export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";